import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import React from 'react';

type StyledStatusProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme?: any;
  color: string;
};

const StyledUnderText = styled.div<StyledStatusProps>`
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${(props) => props.theme.colors.backgroundColor};
  position: relative;
  height: 26px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

const StyledStatusWrapper = styled.div<StyledStatusProps>`
  display: inline-flex;
  position:absolute;
  top:0;
  left:0;
  z-index: 0;
  height:100%;
  width:100%;
  padding: 4px 8px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${(props) => props.color};
  opacity: .25;
`;

const StyledText = styled.span`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  font-family: Mulish;
  font-size: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 1px;
`;

const StatusLabel = ({ status, color }: { status: string; color: string; }) => {
  const theme = useTheme();
  return (
    <StyledUnderText className='status-label-under-text' color={color} theme={theme}>
      <StyledStatusWrapper color={color} theme={theme}></StyledStatusWrapper>
      <StyledText className='status-label-text'>{status}</StyledText>
    </StyledUnderText>
  );
};

export default StatusLabel;